import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.25 4.75843C14.925 4.43343 14.4 4.43343 14.075 4.75843L10 8.8251L5.92501 4.7501C5.60001 4.4251 5.07501 4.4251 4.75001 4.7501C4.42501 5.0751 4.42501 5.6001 4.75001 5.9251L8.82501 10.0001L4.75001 14.0751C4.42501 14.4001 4.42501 14.9251 4.75001 15.2501C5.07501 15.5751 5.60001 15.5751 5.92501 15.2501L10 11.1751L14.075 15.2501C14.4 15.5751 14.925 15.5751 15.25 15.2501C15.575 14.9251 15.575 14.4001 15.25 14.0751L11.175 10.0001L15.25 5.9251C15.5667 5.60843 15.5667 5.0751 15.25 4.75843Z",
		fill: "#1F4C5C"
	})]
});
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
